import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFire = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.97813 2.16953C8.22188 1.94142 8.6 1.94454 8.84375 2.17266C9.70625 2.98199 10.5156 3.85382 11.2719 4.79753C11.6156 4.34755 12.0063 3.85695 12.4281 3.45697C12.675 3.22573 13.0563 3.22573 13.3031 3.46009C14.3844 4.49129 15.3 5.85372 15.9438 7.14741C16.5781 8.42235 17 9.72541 17 10.6441C17 14.6314 13.8813 18 10 18C6.075 18 3 14.6283 3 10.641C3 9.44105 3.55625 7.97549 4.41875 6.52557C5.29063 5.05376 6.52188 3.51946 7.97813 2.16953ZM10.0531 15.0001C10.8438 15.0001 11.5437 14.7814 12.2031 14.3439C13.5188 13.4252 13.8719 11.5878 13.0813 10.1441C12.9406 9.8629 12.5813 9.84415 12.3781 10.0816L11.5906 10.9972C11.3844 11.2347 11.0125 11.2285 10.8187 10.9816C10.3031 10.3254 9.38125 9.15356 8.85625 8.48797C8.65937 8.23798 8.28437 8.23486 8.08437 8.48484C7.02812 9.8129 6.49688 10.6504 6.49688 11.5909C6.5 13.7315 8.08125 15.0001 10.0531 15.0001Z",
		fill: "#0D2976"
	})
});
export default SvgFire;
